function queryParam(names: string[]): string | null {
  if (typeof window === "undefined") return null;
  const params = new URLSearchParams(window.location.search);
  for (const name of names) {
    const value = params.get(name)?.trim();
    if (value) return value;
  }
  return null;
}

/**
 * In-room TV context — required on the agent URL.
 *
 * Examples:
 *   /?deviceId=4D98FF73-660E-4B5F-AF9C-D66D22C10405&tenantKey=ANDOR
 *   /?device_id=6EB05AD6-3293-4D86-AEDF-A0D85FEEB2D1&tenant_key=ANDOR
 */
export function readDeviceIdParam(): string | null {
  return queryParam(["deviceId", "device_id"]);
}

export function readTenantKeyParam(): string | null {
  return queryParam(["tenantKey", "tenant_key"]);
}

/** Both device and tenant query params must be present (non-empty). */
export function hasRequiredRoomParams(): boolean {
  return Boolean(readDeviceIdParam() && readTenantKeyParam());
}

export function getDeviceId(): string {
  return readDeviceIdParam() ?? "";
}

export function getTenantKey(): string {
  return readTenantKeyParam() ?? "";
}
